'use client';

import './payment-method-add-form.scss';

import {
  Form,
  FormProps,
  useFormMethods,
} from '@sola/ark-core/molecules/form/form.js';

export type PaymentMethodAddFormProps = {
  label: string;
  children?: React.ReactNode;
  onSubmit: FormProps['onSubmit'];
};

export const PaymentMethodAddForm: React.FC<PaymentMethodAddFormProps> = ({
  label,
  children,
  onSubmit,
}) => {
  const formMethods = useFormMethods();

  return (
    <div className="PaymentMethodAddForm flex flex-col lg:flex-row w-full space-between gap-comfy-xl">
      <aside className="PaymentMethodAddForm__label">
        <h3 className="label-potent md:label-potent label-md md:label-lg">
          {label}
        </h3>
      </aside>

      <div className="PaymentMethodAddForm__form w-full flex flex-col gap-comfy-xl">
        <Form
          onSubmit={onSubmit}
          formMethods={formMethods}
          isCustomError
          noValidate
        >
          {children}
        </Form>
      </div>
    </div>
  );
};
